import styled from "styled-components";
import { InputContainer } from "../../../../../components/Common/Input/styled";
import { ButtonCommon } from "../../../../../Layout/styled";

export const LiveStakeContainer = styled.div`
  ${ButtonCommon} {
    font-size: 12px;
  }
`;
export const StakeForm = styled.div`
  border-radius: 10px;
  background: #2b2b2e;
  padding: 12px;
  margin-bottom: 15px;
  &.light {
    background-color: #F6F6F6;
  }
`;
export const StakeFormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  gap: 20px;
  & > p {
    font-size: 12px;
    color: #fff;
  }
  & > div {
    display: flex;
    align-items: center;
    p {
      color: #92929e;
      font-size: 12px;
      font-family: DMMono-400;
      padding-right: 5px;
      border-right: 2px solid #fff;
    }
    button {
      outline: none;
      border: none;
      background-color: transparent;
      color: #f9a8a8;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.15s linear;
      &:hover {
        opacity: 0.75;
      }
    }
  }
  &.light {
    & > p {
      color: #000;
    }
    & > div {
      p {
        color: #000;
      }
      button {
        color: #e84142;
      }
    }
  }
`;
export const StakeFormBody = styled.div`
  ${InputContainer} {
    input {
      padding: 0;
      text-align: right;
      color: #fff;
    }
    .ant-input-outlined {
      border-color: transparent;
    }
  }
  &.light {
    ${InputContainer} {
      input {
        color: #000;
      }
    }
  }
`;
export const LiveStakeTitleList = styled.ul`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  &.light {
    & > li {
      border: 0.78px solid var(--Neutral-400, #92929E);
      background: #F3F4F8;
      color: #6E6E7C;
    }
  }
  & > li {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 50%;
    min-height: 40px;
    text-align: center;
    font-family: DMMono-500;
    font-size: 12px;
    border-radius: 8px;
    overflow: hidden;
    background: linear-gradient(
        0deg,
        rgba(232, 65, 66, 0.1) 0%,
        rgba(232, 65, 66, 0.1) 100%
      ),
      #2b2b2e;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -25px;
      background: url("/static/icon_stake_decor.png") no-repeat center / 100%
        auto;
      width: 50px;
      height: 50px;
      opacity: 0.15;
      mix-blend-mode: luminosity;
      pointer-events: none;
    }
    span {
      padding-right: 3px;
    }
  }
`;
